import React, { FC, useState } from "react";
import { Card, Row, Col, Typography, List, Flex } from "antd";
import { UserOutlined, ArrowRightOutlined } from "@ant-design/icons";
import PatientCard from "./PatientCard";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";

dayjs.extend(customParseFormat);

const { Title, Text } = Typography;

export interface HomeScreenComponentProps {
  userName: string;
  todayRegistration: number;
  pendingDocs: number;
  patients: any;
  onAddPatient: () => void;
  handleViewAll: () => void;
  isFetchingPatients: boolean;
}

const HomeScreenComponent: FC<HomeScreenComponentProps> = ({
  userName,
  todayRegistration,
  pendingDocs,
  patients,
  onAddPatient,
  handleViewAll,
  isFetchingPatients,
}) => {
  const cardTitles = [
    { title: "Today's Registrations", count: todayRegistration, width: 12 },
    { title: "PreAuth Pending", count: pendingDocs, width: 12 },
  ];

  const navigate = useNavigate();

  return (
    <div
      style={{ padding: "4px 10px", background: "#F1F8FF", minHeight: "90vh" }}
    >
      {/* Header */}
      <div style={{ marginBottom: 10 }}>
        <Title level={4}>Hello, {userName} ! 👋</Title>
        <Text type="secondary">Good to see you back again</Text>
      </div>

      {/* Stats */}
      <Row gutter={16} style={{ marginBottom: 10 }}>
        {cardTitles?.map((card) => (
          <Col
            span={card.width}
            key={card.title}
            onClick={() => {
              if (card.title === "PreAuth Pending") {
                navigate({
                  pathname: `${ROUTES.PATIENT_LIST}/PreAuth`,
                });
              }
            }}
          >
            <Card bordered={false} className="home-screen-card">
              <Text type="secondary">{card.title}</Text>
              <Title level={3} className="home-screen-card-title">
                {card.count}
              </Title>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Quick Actions */}
      <h4 style={{ margin: "10px 0" }}>Quick Actions</h4>
      <Card
        style={{ marginBottom: 8 }}
        className="home-screen-card"
        onClick={onAddPatient}
      >
        <Flex vertical={true} className="home-screen-add-patient">
          <span
            style={{
              textAlign: "center",
              color: "#004C8F",
              fontWeight: "bold",
              fontSize: "13px",
            }}
          >
            <UserOutlined />
          </span>
          <span>Add Patient</span>
        </Flex>
      </Card>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h5 style={{ margin: "10px 0" }}>Latest Registrations</h5>
        <span
          style={{
            fontSize: "10px",
            color: "#004C8F",
            fontWeight: "semi-bold",
            // cursor: "pointer",
          }}
          onClick={handleViewAll}
        >
          View All <ArrowRightOutlined />
        </span>
      </div>
      <List
        dataSource={patients}
        loading={isFetchingPatients}
        renderItem={(item: any) => (
          <PatientCard
            creditNumber={`${item?.schemeName}-${item.creditNumber}`}
            patientDetails={item}
            name={item.fullName}
            registrationNo={item.claimId}
            date={
              item?.doa
                ? dayjs(item.doa, "DD-MM-YYYY HH:mm:ss").format("DD MMM, YY")
                : "-"
            }
            type={item.visitType}
            uhid={item.uhidNo}
            primaryMobile={item.primaryMobile}
          />
        )}
      />
    </div>
  );
};

export default HomeScreenComponent;
